import { useEffect } from 'react';
import { useApp } from 'providers/useApp/AppContext';
import { useEpgStore } from 'providers/useEpgStore/EpgContext';

/**
 * When the UI language is changed empty every cached data what can have language dependency
 *
 */
export const useUILanguageChangedObserver = () => {
    const { appLanguage } = useApp();

    const { purgeCache } = useEpgStore();

    useEffect(() => {
        purgeCache();
    }, [appLanguage]);
};
